import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../environments/urlService';
import { Observable } from 'rxjs';
import { ReminderRequestDto } from '../dto/reminder-request-dto';
import { ReminderResponseDTO } from '../dto/reminder-response-d-t-o';
import { ReminderUpdateDTO } from '../dto/ReminderUpdateDTO';
import { IS_SPINNER_ACTIVE } from '../../../util/interceptors';

@Injectable({
  providedIn: 'root',
})
export class RemindersService {
  private readonly url: string;

  constructor(private http: HttpClient, private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'reminders/';
  }

  add(req: ReminderRequestDto): Observable<void> {
    return this.http.post<void>(this.url, req, { withCredentials: true,
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true), responseType: 'json' });
  }

  get(orgUuids: string[]): Observable<ReminderResponseDTO[]> {
    return this.http.post<ReminderResponseDTO[]>(this.url + 'get', orgUuids, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  update(req: ReminderUpdateDTO, fundUUID: string): Observable<void> {
    return this.http.put<void>(this.url, req, { withCredentials: true,
      params: { fundUUID },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      responseType: 'json' });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.url, { params: { id: String(id) },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true, responseType: 'json' });
  }
}
